import React from "react";
import Button from "../Button";
import * as styles from "./MinorCTA.module.css";

const MinorCTA = ({ props }) => {
  const { headline, copy, button, backgroundColor } = props;

  return (
    <div
      className={`${styles.minorCTA} ${styles[backgroundColor]}`}
      // data-aos="fade-up"
      // data-aos-duration="300"
    >
      <div>
        <h5 className={styles.headline}>{headline}</h5>
        <div
          dangerouslySetInnerHTML={{
            __html: copy.childMarkdownRemark.html,
          }}
          className={styles.copy}
        />
      </div>
      <div>
        <Button {...button}>{button.title}</Button>
      </div>
    </div>
  );
};

export default MinorCTA;
